// CMS Data Store - Static content management
// This file contains all editable text content across the website
// Will be connected to backend later

const cmsData = {
  // Global Site Settings
  global: {
    siteName: 'OC MENA Festival',
    siteTagline: 'Middle East & North Africa Cultural Festival',
    eventDate: 'June 19-21, 2026',
    eventLocation: 'OC Fairgrounds',
    contactEmail: 'info@ocmenafestival.com',
    copyrightText: '© 2025-2026 OC MENA Festival. All Rights Reserved',
    announcementBar: 'June 19-21, 2026 — OC Fairgrounds — Middle East & North Africa (MENA) Festival!',
  },

  // Home Page
  homePage: {
    heroTitle: 'OC MENA Festival',
    heroSubtitle: 'June 19-21, 2026. Orange County, CA',
    heroDescription: 'Experience three days of Middle Eastern and North African (MENA) culture, food, music, rides, shopping, and family-friendly fun—all in one lively summer festival.',
    countdownTargetDate: 'June 19, 2026 11:00:00',
    welcomeTitle: 'Welcome to OC MENA Festival',
    welcomeText: 'Please browse our site for more information. You can purchase tickets, booths, and inquire about sponsorship opportunities!',
    ctaVendorButton: 'Vendor sign up',
    ctaTicketsButton: 'Get Tickets',
  },

  // About Page
  aboutPage: {
    title: 'About',
    paragraph1: 'The OC MENA Festival is a large-scale celebration honoring the rich traditions, creativity, diversity, and culture of the Arabic-speaking countries of the MENA (Middle East and North Africa). Held in the heart of Orange County, the festival brings communities together through music, art, food, fashion, and immersive experiences that reflect both heritage and modern culture. From vibrant bazaars and live performances to family-friendly attractions and entertainment, OC MENA Festival is designed to be an inclusive space for all ages and backgrounds.',
    paragraph2: "More than just a festival, OC MENA Festival is a gathering rooted in connection, storytelling, and shared experiences. Over three summer days, guests can explore vendor booths, enjoy authentic cuisine, experience live music and performances, and discover the cultural threads that unite generations across the MENA region. Whether you're attending with family, friends, or as a first-time visitor, the OC MENA Festival invites you to celebrate culture, community, and the spirit of summer together.",
  },

  // What is MENA Page
  whatIsMenaPage: {
    title: 'What is MENA?',
    paragraph1: 'MENA stands for the Middle East and North Africa, a diverse and vibrant region that stretches from Morocco in the west to Iran in the east and from Turkey down through the Arabian Peninsula and North Africa. The region is home to dozens of cultures, languages, traditions, and histories that have shaped the world for thousands of years.',
    paragraph2: 'Often described as a bridge between Africa, Asia, and Europe, the MENA region has long been a center of innovation, trade, art, and storytelling. From ancient civilizations and architectural wonders to modern cities and evolving creative scenes, MENA embodies both deep-rooted heritage and forward-looking expression.',
    paragraph3: 'At OC MENA Festival, we celebrate the beauty, resilience, and diversity of the MENA region through food, music, art, fashion, and community. This festival invites you to explore rich, dynamic, and living cultures, honoring tradition while amplifying contemporary voices.',
  },

  // FAQ Page
  faqPage: {
    title: 'FAQ',
    sections: [
      {
        subheading: 'Frequently Asked Questions',
        items: [
          { id: 'f1', question: 'What is the OC MENA Festival?', answer: 'OC MENA Festival is a large-scale cultural celebration honoring the rich traditions, creativity, and diversity of the Middle East and North Africa, held in Orange County.' },
          { id: 'f2', question: 'When and where is the festival?', answer: 'The festival takes place June 19-21, 2026, at the OC Fair & Event Center in Costa Mesa, California. 88 Fair Dr, Costa Mesa, CA 92626' },
          { id: 'f3', question: 'Is the festival family-friendly?', answer: 'Yes! OC MENA Festival is designed to be an inclusive space for people of all ages and backgrounds, featuring family-friendly attractions and entertainment.' },
          { id: 'f4', question: 'Are children free?', answer: 'Children under 3 years old are free to enter.' },
          { id: 'f5', question: 'What can I expect at the festival?', answer: 'Guests can explore vendor booths, enjoy authentic cuisine, experience live music and performances, and discover cultural experiences from the MENA region.' },
          { id: 'f6', question: 'What will the weather be like?', answer: 'Rain or shine. Historically, you can expect daily high temperatures to be around 70°F-75°F and daily low temperatures to be around 60°F-63°F.' },
          { id: 'f7', question: 'Where can I park?', answer: 'Parking is around the venue. It\'s $15, paid directly to the OC Fair & Event Center on-site.' },
          { id: 'f8', question: 'Will there be live music and entertainment?', answer: 'Music will play throughout the festival. There is also an amphitheater section for special guest performances, with assigned seating. Tickets sold separately. Each Amphitheater ticket includes admission to the OC MENA Festival for the same day as the performance. Guests do not need to purchase a separate festival ticket for that day.' },
          { id: 'f9', question: 'Will there be rides?', answer: 'There will be plenty of fun rides.' },
          { id: 'f10', question: 'What will the experience be like?', answer: 'You won\'t want to miss this one. Food, games, rides, music, hookah lounge, bazaars, food booths, food trucks, and more.' },
          { id: 'f11', question: 'Will Festival tickets grant access to The Pacific Amphitheater?', answer: 'No, these tickets are sold separately. The festival ticket allows access to the festival grounds, where there is plenty of fun. The Amphitheater is for seated live performances with special recording artists. The Amphitheater is connected to the festival, but the entrance requires an Amphitheater ticket. Each Amphitheater ticket includes admission to the OC MENA Festival for the same day as the performance. Guests do not need to purchase a separate festival ticket for that day.' },
          { id: 'f12', question: 'Do vendor credentials grant access to The Pacific Amphitheater?', answer: 'No, these tickets are sold separately. The vendor ticket allows access to the festival grounds, where vendors can set up. The Amphitheater is for seated live performances with special recording artists. The Amphitheater is connected to the festival, but the entrance requires an Amphitheater ticket. Each Amphitheater ticket includes admission to the OC MENA Festival for the same day as the performance. Guests do not need to purchase a separate festival ticket for that day.' },
          { id: 'f13', question: 'How many people are expected to attend?', answer: 'We anticipate 20,000–30,000 attendees over the three-day festival.' },
        ]
      }
    ]
  },

  // Amphitheater Page
  amphitheaterPage: {
    title: 'Pacific Amphitheatre',
    subtitle: 'OC MENA Festival · Costa Mesa, CA · June 19-21, 2026',
    daySelectLabel: 'Select Event Day:',
    saturdayButton: 'Saturday June 20',
    sundayButton: 'Sunday June 21',
    bothDaysNote: 'Select seats for one day at a time. You can add both days to your cart separately.',
    ticketQuantityLabel: 'Number of Tickets:',
    selectedSeatsLabel: 'Selected Seats:',
    noSeatsSelected: 'No seats selected',
    totalLabel: 'Total:',
    addToCartButton: 'Add to Cart',
    addingToCartButton: 'Adding...',
    legendTitle: 'Legend',
    legendAvailable: 'AVAILABLE',
    legendSelected: 'SELECTED',
    legendSold: 'SOLD',
    legendAccessible: 'ACCESSIBLE',
  },

  // Tickets Page
  ticketsPage: {
    title: 'OC MENA Festival Tickets',
    intro1: 'Discover the excitement of the OC MENA Festival, a vibrant summer celebration in Orange County inspired by the rich cultures of the Middle East and North Africa. Enjoy three unforgettable days of music, food, carnival rides, cultural showcases, shopping, and family-friendly entertainment.',
    intro2: 'Choose from single-day or full-weekend passes to experience everything the festival has to offer.',
    sectionTitle: 'Tickets',
    parkingNotice: '*Parking is $15, paid directly to the OC Fairgrounds on site. Carpooling is encouraged.',
    ridesNote: '*Rides at event range from $2-$10/person',
    ticketOptions: [
      {
        id: '1day',
        name: '1-Day Pass',
        description: 'Come enjoy the festival for a single day',
        savings: '',
        price: 20,
        salePrice: 15
      },
      {
        id: '2day',
        name: '2-Day Pass',
        description: 'Come enjoy the festival for two days',
        savings: 'Save $5 on entry',
        price: 30,
        salePrice: 25
      },
      {
        id: '3day',
        name: '3-Day Pass',
        description: 'Come enjoy the festival for three days',
        savings: 'Save $10 on entry',
        price: 40,
        salePrice: 35
      }
    ]
  },

  // Contact Page
  contactPage: {
    title: 'Contact',
    subtitle: 'Please fill out the form below or email us at',
    email: 'info@ocmenafestival.com',
    successMessage: "Thank you! We'll get back to you soon.",
    subjectOptions: [
      'Sponsor Inquiry',
      'Vendor Inquiry',
      'General Question',
      'Press Inquiry',
      'Other'
    ],
    formLabels: {
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      submit: 'Send Message',
      submitting: 'Sending...'
    }
  },

  // Festival Info Page
  festivalInfoPage: {
    title: 'Festival Info',
    tabs: [
      { id: 'general', label: 'General Info' },
      { id: 'hours', label: 'Hours' },
      { id: 'howTicketsWork', label: 'How Tickets Work' },
      { id: 'conduct', label: 'Code of Conduct' },
      { id: 'safety', label: 'Public Safety' },
      { id: 'health', label: 'Health & Safety' },
    ],
    generalInfo: {
      title: 'General Info',
      items: [
        'Open to guests of all ages.',
        'Children ages 3 and under receive free General Admission.',
        'Each festival day features vendors, entertainment, food, and activities.',
        'Rain or shine.',
        'All attendees are subject to security screening upon entry.',
        'Programming schedules and performance times may change without notice.*',
        'Food, beverage, and merchandise vendors accept credit, debit, and mobile payments only.',
       
      ]
    },
    hours: {
      title: 'Hours',
      openTitle: 'Open',
      openItems: [
        'General parking opens Friday through Sunday at 11 AM.',
        'Festival grounds open daily at 11 AM.',
      ],
      closeTitle: 'Close',
      closeItems: [
        'Festival grounds close at 12 AM (Midnight) each day.',
              ],
      notes: [
        'View additional parking and transportation details for more information.',
        '*All details, schedules, and hours are subject to change.',
      ]
    },
    codeOfConduct: {
      title: 'Code of Conduct',
      intro: 'OC MENA Festival and MENA Events, Inc are dedicated to providing a safe, respectful, and family-friendly environment for all attendees, artists, vendors, and staff. All guests are expected to behave responsibly and treat others with courtesy and respect throughout the event.',
      prohibitedIntro: 'The following behaviors are strictly prohibited and may result in removal from the festival grounds:',
      prohibitedItems: [
        'Use of offensive, hateful, or inappropriate language, whether spoken, displayed on clothing, or shown on personal items',
        'Excessive intoxication or behavior that indicates impairment due to alcohol consumption',
        'Possession of prohibited items within the festival or designated event areas',
        'Throwing objects, liquids, or substances of any kind',
        'Harassing, threatening, aggressive, or disruptive conduct, including obscene gestures or imagery',
        'Entering restricted or staff-only areas, including stages, without proper authorization',
        'Public indecency, including inappropriate exposure or use of festival grounds as restrooms',
        'Engaging in sexual activity in public areas',
        'Possession, use, or distribution of illegal substances',
        'Physical altercations or actions that may endanger the safety or comfort of others',
        'Damage, vandalism, theft, or misuse of festival property or the property of others',
        'Misuse or fraudulent claims related to accessibility accommodations',
        'Blocking fire lanes, emergency access routes, or pedestrian walkways',
        'Any violation of local, state, or federal laws',
      ],
      enforcement: 'Festival management reserves the right to enforce this Code of Conduct at their discretion. Any individual or group found in violation may be removed from the event immediately, have their wristbands revoked, and be denied re-entry. Vehicles associated with violations may be removed from the premises. Law enforcement may be involved when necessary.',
      refundPolicy: 'No refunds will be issued for removal due to Code of Conduct violations.',
    },
    publicSafety: {
      title: 'Public Safety',
      paragraphs: [
        'The safety and well-being of our guests, vendors, performers, and staff are a top priority at OC MENA Festival. We collaborate closely with local law enforcement, emergency services, and professional security teams to help ensure a safe and welcoming environment throughout the event. For security reasons, we do not publicly disclose specific operational details.',
        'Guests should expect standard safety procedures upon arrival, which may include bag inspections, security screenings, and walk-through detection systems at entry points. These measures apply to all attendees, staff, vendors, and performers. To help ensure a smooth entry experience, we encourage guests to arrive early and review the Prohibited Items list in advance. Items not permitted inside the festival will be denied entry and must be returned to vehicles or properly discarded.',
        'In the event of an emergency or important safety announcement, information may be shared through on-site video screens, public address systems, festival staff, or official digital communications. If you or someone nearby requires medical assistance, please visit the nearest medical tent or notify a staff or security team member immediately. We also encourage everyone to remain aware of their surroundings—if you see something concerning, please report it to a festival staff member or public safety official.',
      ],
      entryTitle: 'What to Expect at Entry',
      entryText: 'For the safety of all guests, OC MENA Festival conducts standard security screenings at all entry points. All attendees may be subject to bag checks and walk-through security screening. Please arrive early, review the Prohibited Items list in advance, and follow instructions from festival staff and security personnel for a smooth entry experience.',
    },
    healthSafety: {
      title: 'Health & Safety',
      medicalTitle: 'Medical Services',
      medicalText: 'Basic Life Support (BLS) and Advanced Life Support (ALS) medical services will be available to all attendees throughout OC MENA Festival. Medical tents will be located at designated areas across the festival grounds and clearly marked on festival maps. Our trained medical teams are available to assist—if you or someone with you is feeling unwell or needs attention, please visit a medical tent or notify a staff member immediately.',
      policiesTitle: 'Health & Safety Policies',
      policiesText: [
        'OC MENA Festival will operate in accordance with all applicable public health guidelines and requirements in effect at the time of the event. These guidelines may be issued by federal, state, or local authorities and are subject to change. Health and safety measures may include, but are not limited to, adjustments to attendance procedures, capacity limits, or other protective protocols as required.',
        'Failure to comply with applicable health directives, festival policies, or posted instructions may result in denied entry or removal from the event without refund.',
      ],
      covidTitle: 'Public Health Notice (COVID-19)',
      covidText: [
        'COVID-19 is a contagious illness that may result in serious health complications. Attendance at any large public gathering carries an inherent risk of exposure to infectious diseases, including COVID-19. OC MENA Festival cannot guarantee that attendees will not be exposed during the event.',
        'Guests are encouraged to assess their personal health conditions and take appropriate precautions prior to attending.',
      ],
      acknowledgementTitle: 'Attendee Health Acknowledgement',
      acknowledgementText: 'By attending OC MENA Festival, all guests agree to comply with festival health and safety policies, posted signage, and staff instructions. Attendance is voluntary, and all attendees assume responsibility for assessing their individual health risks. By entering the festival grounds, guests acknowledge and accept the risks associated with participation in a public event and agree to follow all applicable federal, state, and local health guidelines.',
    }
  },

  // Sponsors Page
  sponsorsPage: {
    title: 'Sponsors',
    description: "OC MENA Festival partners with brands and organizations that support culture, community, and live experiences. Sponsorship opportunities are designed to create meaningful engagement with our audience while aligning your brand with one of Orange County's premier cultural events. We offer multiple sponsorship tiers with customizable benefits, including on-site visibility, digital promotion, experiential activations, and branded integrations throughout the festival.",
    levelsTitle: 'Sponsorship Levels:',
    levels: ['Diamond', 'Platinum', 'Gold', 'Silver', 'Bronze'],
    levelsDescription: 'Each level offers unique exposure opportunities, and custom packages are available upon request.',
    contactText: "If you're interested in becoming a sponsor or would like to receive our sponsorship deck, please contact us here. A member of our team will be in touch to discuss available opportunities and tailor a package that fits your goals.",
    ctaText: 'Ready to become a sponsor?',
    ctaButton: 'Inquire Now',
  },

  // Sponsors Info Page
  sponsorsInfoPage: {
    title: 'Sponsors',
    paragraph1: "OC MENA Festival partners with brands and organizations that support culture, community, and live experiences. Sponsorship opportunities are designed to create meaningful engagement with our audience while aligning your brand with one of Orange County's premier cultural events.",
    paragraph2: 'We offer multiple sponsorship tiers with customizable benefits, including on-site visibility, digital promotion, experiential activations, and branded integrations throughout the festival.',
    levelsTitle: 'Sponsorship Levels:',
    levels: ['Diamond', 'Platinum', 'Gold', 'Silver', 'Bronze'],
    levelsDescription: 'Each level offers unique exposure opportunities, and custom packages are available upon request.',
    contactText: "If you're interested in becoming a sponsor or would like to receive our sponsorship deck, please contact us. A member of our team will be in touch to discuss available opportunities and tailor a package that fits your goals.",
    ctaTitle: 'Ready to become a sponsor?',
    ctaButton: 'Inquire Now',
  },

  // About Vendors Page
  aboutVendorsPage: {
    title: 'About Our Vendors',
    paragraph1: 'Get ready to explore a vibrant mix of vendors from across the region and beyond. OC MENA Festival brings together food, art, fashion, culture, and community in one dynamic marketplace designed to be discovered.',
    paragraph2: 'From mouth-watering eats and refreshing drinks to handcrafted goods, apparel, accessories, and cultural merchandise, our vendor village is curated to reflect the creativity, flavors, and traditions of the MENA community — with plenty of surprises along the way.',
    paragraph3: "You'll find local favorites, emerging brands, and unique makers offering everything from savory street food and sweet treats to statement pieces and lifestyle finds you won't see anywhere else. Whether you're here to eat, shop, browse, or simply soak in the energy, the vendor experience is a core part of the festival vibe.",
    paragraph4: 'Come hungry, come curious, and come ready to support incredible vendors who help make OC MENA Festival an unforgettable celebration.',
    vendorListTitle: 'Vendor List',
    vendorListText: "We'll release the list of vendors as the event date nears",
  },

  // Vendors Page
  vendorsPage: {
    title: 'About Our Vendors',
    paragraph1: 'Get ready to explore a vibrant mix of vendors from across the region and beyond. OC MENA Festival brings together food, art, fashion, culture, and community in one dynamic marketplace designed to be discovered.',
    paragraph2: 'From mouth-watering eats and refreshing drinks to handcrafted goods, apparel, accessories, and cultural merchandise, our vendor village is curated to reflect the creativity, flavors, and traditions of the MENA community — with plenty of surprises along the way.',
    paragraph3: "You'll find local favorites, emerging brands, and unique makers offering everything from savory street food and sweet treats to statement pieces, gifts, and lifestyle finds you won't see anywhere else. Whether you're here to eat, shop, browse, or simply soak in the energy, the vendor experience is a core part of the festival vibe.",
    paragraph4: 'Come hungry, come curious, and come ready to support incredible vendors who help make OC MENA Festival an unforgettable celebration.',
    vendorListTitle: 'Vendor List',
    vendorListText: "We'll release the list of vendors as the event date nears",
  },

  // Maps & Directions Page
  mapsDirectionsPage: {
    title: 'Maps & Directions',
    content: 'More information will be announced soon. Please visit the OC Fair & Events Center page using this link: https://ocfair.com/about-us/maps-directions/ for the maps and directions page.',
  },

  // Event Map Page
  eventMapPage: {
    title: 'Event Map',
    description: "Your festival adventure starts here. The OC MENA Festival event map helps you navigate the grounds with ease — from live music stages and vendor bazaars to food, drinks, restrooms, medical tents, and accessibility services. Whether you're chasing your favorite performances or discovering something new, the map makes it easy to explore, plan your route, and soak in every moment.",
  },

  // Event Schedule Page
  eventSchedulePage: {
    title: 'Event Schedule',
    description: 'The countdown is on. Our full lineup of performances, experiences, and special moments will be announced soon. Get ready to plan your day, discover new favorites, and catch every unforgettable moment at OC MENA Festival.',
    newsletterHeading: 'Subscribe to our newsletter to stay informed!',
    newsletterSuccess: "Thank you for subscribing! We'll notify you when the lineup is announced.",
    newsletterButton: 'Sign Up',
    newsletterButtonLoading: 'Signing up...',
  },

  // Login Page
  loginPage: {
    title: 'My Account',
    loginTab: 'Login',
    registerTab: 'Register',
    loginHeading: 'Login',
    emailLabel: 'Username or email address *',
    emailPlaceholder: 'Enter your username or email',
    passwordLabel: 'Password *',
    passwordPlaceholder: 'Enter your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    submitButton: 'Sign In',
    submittingButton: 'Signing in...',
  },

  // Signup Page
  signupPage: {
    title: 'My Account',
    loginTab: 'Login',
    registerTab: 'Register',
    registerHeading: 'Register',
    emailLabel: 'Email address *',
    emailPlaceholder: 'Enter your email address',
    passwordLabel: 'Password *',
    passwordPlaceholder: 'Enter your password',
    privacyNotice: 'Your personal data will be used to support your experience throughout this website, to manage access to your account, and for other purposes described in our privacy policy.',
    submitButton: 'Register',
    submittingButton: 'Registering...',
  },

  // Vendor Booths Page
  vendorBoothsPage: {
    title: 'OC MENA Festival Vendor Booths',
    intro1: "Join us at the OC MENA Festival, one of Orange County's most exciting cultural events, bringing together thousands of families and visitors for three days of food, shopping, music, and entertainment inspired by the Middle East and North Africa.",
    intro2: 'Showcase your products, cuisine, services, or brand in a vibrant festival environment filled with energy and community engagement. With a variety of booth options available, vendors can choose the ideal space to connect with guests, drive sales, and be part of an unforgettable summer celebration.',
    intro3: 'Explore the booth packages and secure your spot today—spaces are limited and fill quickly each year.',
    selectBoothTitle: 'Please select a booth option:',
    registrationTitle: 'Vendor Registration',
    continueButton: 'Continue to Checkout',
    boothOptions: [
      {
        id: 'bazaar',
        name: '10x10 Bazaar Booth',
        description: 'Sell goods inside the decorated bazaar',
        price: 500,
        includes: ['10x10 booth', 'Vendor credentials', '4 guest entry tickets', '1 parking ticket'],
        upgradeText: "Upgrade to 20'x10' (+$250)",
        upgrades: [
          { size: '20x10', price: 750 },
          { size: '20x20', price: 1000 },
        ],
      },
      {
        id: 'food-truck',
        name: 'Food/Beverage Truck',
        description: 'Serve guests from your mobile kitchen',
        price: 2000,
        includes: ['Food/Beverage truck parking spot', 'Vendor credentials', '4 guest entry tickets', '1 parking ticket'],
      },
      {
        id: 'food-booth',
        name: '10x10 Food/Beverage Booth',
        description: 'Serve food from a fixed booth space',
        price: 1000,
        includes: ['10x10 booth', 'Vendor credentials', '4 guest entry tickets', '1 parking ticket'],
        upgradeText: "Upgrade to 20'x10' (+$500)",
        upgrades: [
          { size: '20x10', price: 1500 },
          { size: '20x20', price: 2000 },
        ],
      }
    ],
    formLabels: {
      email: 'Email*',
      legalName: 'Legal Business Name*',
      boothName: 'Booth Name*',
      phone: 'Phone Number*',
      instagram: 'Instagram Handle',
      facebook: 'Facebook Handle',
      tiktok: 'TikTok Handle',
    },
    bazaarTerms: "I understand that I can set up my booth starting Friday evening and Saturday morning from 8 AM to 11 AM. After 11 AM, I won't be able to set up my booth and I won't get any refunds. Also, if I am handling any food whether it is packaged or non packaged I would require OC MENA Festival approval*",
    acceptTermsLabel: 'I accept the terms above',
  },

  // Privacy Policy Page
  privacyPolicyPage: {
    title: 'Privacy Policy',
    effectiveDate: 'Effective Date: January 1, 2026',
    intro: 'MENA Events, Inc ("MENA Events," "we," "us," or "our") respects your privacy and is committed to protecting your personal information. This Privacy Policy describes how we collect, use, disclose, and safeguard information in connection with OC MENA Festival and our related services.',
    scope: 'This Policy applies to information collected through our websites, ticketing platforms, mobile applications, social media pages, in-person events, and other services we operate or provide (collectively, the "Services").',
    sections: [
      {
        title: 'Who We Are',
        content: 'MENA Events, Inc is the organizer and operator of OC MENA Festival, a live cultural and entertainment event. We produce, promote, and manage festival experiences, including ticketed events, vendor participation, digital services, and on-site operations.',
      },
      {
        title: 'Personal Data We Collect',
        content: '"Personal Data" means information that identifies, relates to, describes, or can reasonably be linked to you or your household.',
      },
    ],
    contactInfo: {
      company: 'MENA Events, Inc',
      email: 'info@ocmenafestival.com',
      website: 'ocmenafestival.com',
    },
  },

  // CPRA Notice Page
  cpraNoticePage: {
    title: 'California Privacy Rights (CPRA Notice)',
    intro: 'This section applies only to California residents and supplements the Privacy Policy above. It is provided in accordance with the California Consumer Privacy Act, as amended by the California Privacy Rights Act ("CPRA").',
    contactInfo: {
      company: 'MENA Events, Inc',
      email: 'info@ocmenafestival.com',
      website: 'ocmenafestival.com',
    },
  },

  // Accessibility Page
  accessibilityPage: {
    title: 'Accessibility / ADA',
    content: 'Accessibility and ADA information coming soon. Please contact info@ocmenafestival.com for any questions or click here.',
  },

  // Terms of Use Page
  termsOfUsePage: {
    title: 'Terms of Use',
    effectiveDate: 'Last updated and effective: 1/5/2026',
    contactInfo: {
      company: 'MENA Events, Inc',
      email: 'info@ocmenafestival.com',
    },
  },

  // Ticket Terms Page
  ticketTermsPage: {
    title: 'Ticket Terms & Conditions',
    effectiveDate: 'Effective Date: January 1, 2026',
    intro: 'Please read these OC MENA Festival Ticket Terms ("Terms" or "Agreement") carefully, as they affect your legal rights. These Terms apply to admission to OC MENA Festival (the "Event"), produced by MENA Events, Inc ("Event Producer").',
  },

  // Site Images (editable paths - admin can replace files in /public)
  // Only images that are actually rendered on the site are listed here.
  siteImages: {
    // Global / Layout
    logo: { path: '/logo.webp', label: 'Site Logo', usedOn: 'Header, Scanner, CMS Dashboard, CMS Login, Success Page' },
    logo2: { path: '/logo-2.webp', label: 'Alternate Logo (Mobile)', usedOn: 'Header (mobile)' },
    headerLogoGlow: { path: '/ocmenafest-temp-logo-white-glow-010626-v2.webp', label: 'Header Glow Logo', usedOn: 'Header (before scroll)' },
    heroVideo: { path: '/hero-final.mp4', label: 'Hero Background Video', usedOn: 'All pages (hero background)' },
    lanterns: { path: '/lanterns.webp', label: 'Lanterns Decoration', usedOn: 'All pages (bottom decoration)' },
    footerImage: { path: '/footer-image-scaled.webp', label: 'Footer Background', usedOn: 'Footer (all pages)' },
    paperTornTop: { path: '/paper-torn-top.webp', label: 'Paper Torn Edge (Top)', usedOn: 'Home Page, TornPaperWrapper' },
    paperTornBottom: { path: '/paper-torn-bottom.webp', label: 'Paper Torn Edge (Bottom)', usedOn: 'Home Page, TornPaperWrapper' },
    ogImage: { path: '/og-image.jpg', label: 'Open Graph Share Image', usedOn: 'All pages (social sharing preview)' },

    // Home Page
    orangeCountySign: { path: '/orange-county-sign-c.webp', label: 'Orange County Sign', usedOn: 'Home Page' },
    officialFlyer: { path: '/ocmena-official-flyer(1080x1350).webp', label: 'Official Festival Flyer', usedOn: 'Home Page, Tickets Page' },

    // What is MENA Page
    menaMap: { path: '/mena-map-c-768x512.webp', label: 'MENA Region Map', usedOn: 'What is MENA Page' },

    // Music Page
    stadiumImage: { path: '/stadium.webp', label: 'Stadium/Amphitheater', usedOn: 'Music Page, Tickets Page' },
    tbaArtist: { path: '/tba.webp', label: 'TBA Artist Graphic', usedOn: 'Music Page' },

    // Dystinct Artist Page
    dystinctPortrait: { path: '/dystinct.webp', label: 'Dystinct Portrait', usedOn: 'Music Page, Dystinct Page' },
    dystinctFlag: { path: '/flag.webp', label: 'Morocco Flag', usedOn: 'Dystinct Page' },
    dystinctName: { path: '/dystinct_name.webp', label: 'Dystinct Name Graphic', usedOn: 'Dystinct Page' },
    billboardImage: { path: '/billboard.webp', label: 'Billboard Arabic Hot 100', usedOn: 'Dystinct Page' },

    // Ehab Tawfik Artist Page
    ehabPortrait: { path: '/ehab.webp', label: 'Ehab Tawfik Portrait', usedOn: 'Music Page, Ehab Tawfik Page' },
    ehabFlag: { path: '/egypt.webp', label: 'Egypt Flag', usedOn: 'Ehab Tawfik Page' },

    // Mohammed Assaf Artist Page
    assafPortrait: { path: '/assaf.webp', label: 'Mohammed Assaf Portrait', usedOn: 'Music Page, Mohammed Assaf Page' },
    assafFlag: { path: '/flag_2.webp', label: 'Palestinian Flag', usedOn: 'Mohammed Assaf Page' },
    assafName: { path: '/name.webp', label: 'Mohammed Assaf Name Graphic', usedOn: 'Mohammed Assaf Page' },
    arabIdolLogo: { path: '/arab_idol.webp', label: 'Arab Idol Logo', usedOn: 'Mohammed Assaf Page' },
    arabIdolPerformance: { path: '/arab_idol_2.webp', label: 'Arab Idol Performance', usedOn: 'Mohammed Assaf Page' },

    // Tickets Page
    festivalTicketsCard: { path: '/festival2.webp', label: 'Festival Tickets Card', usedOn: 'Tickets Page' },
    product1DayTickets: { path: '/product-1-day-tickets.webp', label: '1-Day Ticket Card', usedOn: 'Festival Tickets Page' },
    product2DayTickets: { path: '/product-2-day-tickets.webp', label: '2-Day Ticket Card', usedOn: 'Festival Tickets Page' },
    product3DayTickets: { path: '/product-3-day-tickets.webp', label: '3-Day Ticket Card', usedOn: 'Festival Tickets Page' },

    // Product Images (Cart, Checkout, Orders)
    product1Day: { path: '/product-1-day.webp', label: '1-Day Pass Product', usedOn: 'Cart, Checkout, Orders' },
    product2Day: { path: '/product-2-day.webp', label: '2-Day Pass Product', usedOn: 'Cart, Checkout, Orders' },
    product3Day: { path: '/product-3-day.webp', label: '3-Day Pass Product', usedOn: 'Cart, Checkout, Orders' },
    productBazaar: { path: '/product-vendor-bazaar-booth.webp', label: 'Bazaar Booth Product', usedOn: 'Cart, Checkout, Orders' },
    productFoodBooth: { path: '/product-vendor-food-booth.webp', label: 'Food Booth Product', usedOn: 'Cart, Checkout, Orders' },
    productFoodTruck: { path: '/product-vendor-food-truck.webp', label: 'Food Truck Product', usedOn: 'Cart, Checkout, Orders' },

    // Vendor Pages
    vendorBazaarCard: { path: '/bazaar.webp', label: 'Bazaar Vendor Card', usedOn: 'Vendor Funnel Page' },
    vendorFoodCard: { path: '/food.webp', label: 'Food Vendor Card', usedOn: 'Vendor Funnel Page' },

    // Sponsors Page
    libertyLogo: { path: '/Liberty-Debt-Relief-Logo-all-white-2025.svg', label: 'Liberty Debt Relief Logo', usedOn: 'Sponsors Section (all pages)' },
    festivalZoneIcon: { path: '/festival-zone.svg', label: 'Festival Zone Icon', usedOn: 'Sponsors Page' },
    fifaIcon: { path: '/fifa.svg', label: 'Watch Party Zone Icon', usedOn: 'Sponsors Page' },
    hookahLoungeIcon: { path: '/hookah-lounge.svg', label: 'Hookah Lounge Icon', usedOn: 'Sponsors Page' },
    stageIcon: { path: '/stage.svg', label: 'Stage Icon', usedOn: 'Sponsors Page' },
    foodCourtIcon: { path: '/food-court.svg', label: 'Food Court Icon', usedOn: 'Sponsors Page' },
    ticketsIcon: { path: '/tickets.svg', label: 'Tickets Icon', usedOn: 'Sponsors Page' },

    // Wallet Badges (Success Page, Dashboard)
    appleBadge: { path: '/apple.webp', label: 'Apple Wallet Badge', usedOn: 'Success Page, Dashboard' },
    googleWalletBadge: { path: '/enUS_add_to_google_wallet_add-wallet-badge.svg', label: 'Google Wallet Badge', usedOn: 'Success Page, Dashboard' },

    // Dashboard Social Toolkit
    flagPostExample: { path: '/new_flyer/Flag Post New Exports/OCMENA-Flag-Post-Example.webp', label: 'Flag Post Example (Dark)', usedOn: 'Dashboard - Social Toolkit' },
    flagPostTemplate: { path: '/new_flyer/OCMENA-Flag-Post-Template.webp', label: 'Flag Post Template (Dark)', usedOn: 'Dashboard - Social Toolkit' },
    flagPostExample1: { path: '/new_flyer/Flag Post New Exports/OCMENA-Flag-Post-Example-1.webp', label: 'Flag Post Example (Light)', usedOn: 'Dashboard - Social Toolkit' },
    flagPostTemplate1: { path: '/new_flyer/Flag Post New Exports/OCMENA-Flag-Post-Template-1.webp', label: 'Flag Post Template (Light)', usedOn: 'Dashboard - Social Toolkit' },
    vendorOutputPost: { path: '/Personalized Social Posts/ocmena-vendor-output.webp', label: 'Vendor Output Post', usedOn: 'Dashboard - Social Toolkit' },
    vendorInitialLoad: { path: '/ocmena-vendor-inital-load.webp', label: 'Vendor Initial Load', usedOn: 'Dashboard - Social Toolkit' },
    couponPostA: { path: '/Coupon & Promotion Posts/OCMENA-Coupon-A.webp', label: 'Coupon Post A', usedOn: 'Dashboard - Social Toolkit' },
    couponPostB: { path: '/Coupon & Promotion Posts/OCMENA-Coupon-B.webp', label: 'Coupon Post B', usedOn: 'Dashboard - Social Toolkit' },
    attendingPost: { path: '/OCMENA-Attending-Post.webp', label: 'I\'m Attending Post', usedOn: 'Dashboard - Social Toolkit' },
    officialFestivalPost: { path: '/Official Festival Posts/OCMENA-Festival.webp', label: 'Official Festival Post', usedOn: 'Dashboard - Social Toolkit' },
    officialDystinctPost: { path: '/Official Festival Posts/OCMENA-Dystinct.webp', label: 'Official Dystinct Post', usedOn: 'Dashboard - Social Toolkit' },
    officialVideoPost: { path: '/Official Festival Posts/OCMENA-Video.mp4', label: 'Official Video Post', usedOn: 'Dashboard - Social Toolkit' },
    pencilIcon: { path: '/Pencil.svg', label: 'Pencil Icon', usedOn: 'Dashboard - Personalize Button' },
    angleDownIcon: { path: '/angle-down-regular.svg', label: 'Menu Arrow Icon', usedOn: 'Dashboard - Mobile Sidebar' },

    // Amphitheater / Stadium Page
    stagePng: { path: '/stage.webp', label: 'Stage Photo', usedOn: 'Amphitheater Page' },
    handicapSymbol: { path: '/handicap-symbol.svg', label: 'ADA/Handicap Symbol', usedOn: 'Amphitheater Page' },
    pitImage: { path: '/pit.webp', label: 'Pit Section View', usedOn: 'Amphitheater Page' },
    circleImage: { path: '/circle.webp', label: 'Circle Section View', usedOn: 'Amphitheater Page' },
    section1Image: { path: '/section1.webp', label: 'Section 1 View', usedOn: 'Amphitheater Page' },
    section2Image: { path: '/section2.webp', label: 'Section 2 View', usedOn: 'Amphitheater Page' },
    section3Image: { path: '/section3.webp', label: 'Section 3 View', usedOn: 'Amphitheater Page' },
    section4Image: { path: '/section4.webp', label: 'Section 4 View', usedOn: 'Amphitheater Page' },
    section5Image: { path: '/section5.webp', label: 'Section 5 View', usedOn: 'Amphitheater Page' },
    section6Image: { path: '/section6.webp', label: 'Section 6 View', usedOn: 'Amphitheater Page' },
    section7Image: { path: '/section7.webp', label: 'Section 7 View', usedOn: 'Amphitheater Page' },
    section8Image: { path: '/section8.webp', label: 'Section 8 View', usedOn: 'Amphitheater Page' },
    boxSeatsImage: { path: '/box-seats-cleaned-web.webp', label: 'Box Seats View', usedOn: 'Amphitheater Page' },
  },

  // Header Navigation
  header: {
    navItems: [
      { name: 'FESTIVAL', path: '/festival' },
      { name: 'MUSIC', path: '/music' },
      { name: 'MUSIC TICKETS', path: '/amphitheater-tickets' },
      { name: 'VENDORS', path: '/vendors' },
      { name: 'SPONSORS', path: '/sponsors' },
      { name: 'CONTACT', path: '/contact' },
    ],
    getTicketsButton: 'Get Tickets',
    cartLabel: 'Cart',
    accountLabel: 'Account',
    dashboardLabel: 'Dashboard',
  },

  // Footer
  footer: {
    companyLinks: [
      { label: 'About', path: '/about' },
      { label: 'What is MENA?', path: '/what-is-mena' },
      { label: 'FAQ', path: '/faq' },
      { label: 'My Account', path: '/login' },
      { label: 'Contact', path: '/contact' },
    ],
    eventInfoLinks: [
      { label: 'Festival', path: '/festival' },
      { label: 'Sponsors', path: '/sponsors-info' },
      { label: 'Vendors', path: '/vendors' },
      { label: 'Maps & Directions', path: '/maps-directions' },
      { label: 'Event Map', path: '/event-map' },
      { label: 'Event Schedule', path: '/event-schedule' },
    ],
    legalLinks: [
      { label: 'Privacy Policy', path: '/privacy-policy' },
      { label: 'CA Privacy Policy', path: '/cpra-notice' },
      { label: 'Accessibility / ADA', path: '/accessibility' },
      { label: 'Terms of Use', path: '/terms-of-use' },
      { label: 'Ticket Terms', path: '/ticket-terms' },
    ],
    socialLinks: {
      instagram: 'https://www.instagram.com/ocmenafestival',
      tiktok: 'https://www.tiktok.com/@ocmenafestival',
      youtube: 'https://www.youtube.com/@ocmenafestival',
      facebook: 'https://www.facebook.com/menafestival',
      twitter: 'https://x.com/ocmenafestival',
      snapchat: 'https://www.snapchat.com/add/ocmenafestival',
    },
    newsletterLabel: 'Newsletter',
    newsletterText: 'Join our newsletter and stay informed!',
  },

  // Music Page
  musicPage: {
    title: 'Music & Entertainment',
    description: 'Experience an unforgettable lineup of artists and performers at the OC MENA Festival.',
    amphitheaterTitle: 'A Unique Music Venue Experience',
    amphitheaterDescription: 'Amphitheater tickets are a premium, separately ticketed concert experience at the Pacific Amphitheatre with reserved seating. Artists are TBA soon!',
    amphitheaterNotice: 'Each Amphitheater ticket includes admission to the OC MENA Festival for the same day as the performance. Guests do not need to purchase a separate festival ticket for that day.',
  },

  // Dystinct Artist Page
  dystinctPage: {
    name: 'Dystinct',
    tagline: 'Moroccan-Dutch singer and songwriter',
    bioShort: 'Born Saïd Amine Amzil, known as Dystinct, is a Moroccan-Dutch singer, songwriter, and producer who has taken the global music scene by storm.',
    bioFull: 'Born Saïd Amine Amzil on March 23, 2001, Dystinct grew up in the Netherlands with deep Moroccan roots. He burst onto the international stage with viral hits that blend Afrobeats, Latin pop, and North African rhythms into a sound entirely his own. His breakout single "Ghazali" featuring Bryan MG amassed over 120 million YouTube views, establishing him as one of the most exciting young artists bridging European and MENA music scenes. With collaborations alongside French rap icon GIMS, MHD, and Naza, Dystinct continues to push boundaries and connect cultures through music. His Red Bull Symphonic performance showcased his artistic range, reimagining his catalog with a full orchestra.',
    instagramUrl: 'https://www.instagram.com/dystinct/',
    tiktokUrl: 'https://www.tiktok.com/@dystinct',
    spotifyUrl: 'https://open.spotify.com/artist/6JfKMhNiLhMJMF46ZMqtBB',
    youtubeUrl: 'https://www.youtube.com/@DYSTINCT',
    facebookUrl: 'https://www.facebook.com/dystinctofficial',
    twitterUrl: 'https://twitter.com/dystinct_',
    snapchatUrl: '',
    videos: [
      { id: 'QRHhWwdX59k', title: 'Dystinct - YAMA', views: '12M Views' },
      { id: 'Z8_ybWzumGQ', title: 'GIMS & Dystinct - SPIDER', views: '21M Views' },
      { id: 'xRoaPdBcxAU', title: 'Dystinct - Ghazali ft. Bryan MG', views: '120M Views' },
      { id: 'hdO188j42ys', title: 'MENA 4 x Dystinct x YAM - DABBA BADIYA', views: '101M Views' },
      { id: 'qmfr0A3vZQg', title: 'Dystinct - Tek Tek ft. MHD', views: '85M Views' },
      { id: 'NLXiGXbxl6Q', title: 'Dystinct - Business ft. Naza', views: '85M Views' },
      { id: '4R5zsoxjARk', title: 'Dystinct - TA3AL', views: '120M Views' },
      { id: 'R361oM6pBn8', title: 'Dystinct - Red Bull Symphonic (Full Performance)', views: 'Just added' },
    ],
  },

  // Ehab Tawfik Artist Page
  ehabTawfikPage: {
    name: 'Ehab Tawfik',
    tagline: 'Egyptian legend of Arabic pop music',
    bioShort: 'Ehab Tawfik is one of the most iconic Egyptian singers in the history of Arabic pop music, known for his powerful voice and timeless classics.',
    bioFull: 'Ehab Tawfik (born March 20, 1966) is an Egyptian singer and actor who has been a dominant force in Arabic music for over three decades. Known for his distinctive tenor voice and romantic ballads, Ehab rose to fame in the 1990s with hits that became staples of Arabic pop culture. His catalog spans romantic pop, patriotic anthems, and contemporary Arabic music, earning him millions of fans across the Middle East and North Africa. With numerous platinum albums and awards to his name, Ehab Tawfik continues to captivate audiences with live performances that showcase the depth and emotion of his legendary voice.',
    instagramUrl: 'https://www.instagram.com/ehabtawfikofficial/',
    youtubeUrl: 'https://www.youtube.com/@EhabTawfikOfficial',
    facebookUrl: 'https://www.facebook.com/EhabTawfikOfficial',
    twitterUrl: '',
    spotifyUrl: 'https://open.spotify.com/artist/4eCm1wGFN7sYzOvPF3ukSi',
    videos: [],
  },

  // Mohammed Assaf Artist Page
  mohammedAssafPage: {
    name: 'Mohammed Assaf',
    tagline: 'Palestinian icon and Arab Idol winner',
    bioShort: 'Mohammed Assaf is a Palestinian singer who captured the hearts of millions as the winner of Arab Idol Season 2 in 2013.',
    bioFull: 'Mohammed Assaf (born September 1, 1989) is a Palestinian singer and UNRWA Youth Ambassador who rose to international fame after winning Arab Idol Season 2 in 2013. His journey from the refugee camps of Khan Younis, Gaza to become one of the most beloved voices in the Arab world is a story of perseverance and extraordinary talent. Known for his powerful vocals and passionate performances of Palestinian folk music, patriotic songs, and modern Arabic pop, Assaf has become a symbol of hope and cultural pride. His story was immortalized in the 2015 film "The Idol," and he continues to perform to sold-out crowds worldwide.',
    instagramUrl: 'https://www.instagram.com/mohammedassaf/',
    youtubeUrl: 'https://www.youtube.com/@MohammedAssafOfficial',
    facebookUrl: 'https://www.facebook.com/MohammedAssafOfficial',
    twitterUrl: 'https://twitter.com/MohammedAssaf',
    spotifyUrl: 'https://open.spotify.com/artist/5FAqIVHrQnJ68zcH6Cv0Fm',
    tiktokUrl: '',
    videos: [],
  },

  // Partners Page
  partnersPage: {
    title: 'Become a Partner',
    subtitle: 'Join the OC MENA Festival team',
    description: 'Are you an influencer, brand, photographer, or creative? Partner with OC MENA Festival and be part of something special.',
    formTitle: 'Partner Application',
    partnerTypes: ['Influencer', 'Brand/Company', 'Media', 'Photographer', 'Videographer', 'Decorator', 'Artist', 'DJ'],
    affiliateTerms: '',
    successMessage: 'Thank you for your application! Our team will review it and get back to you soon.',
  },

  // SEO Metadata & Share Images (per-page)
  seoMetadata: {
    defaultShareImage: 'https://www.ocmenafestival.com/og-image.jpg',
    pages: {
      home: {
        title: 'OC MENA Festival | June 19-21, 2026 | Costa Mesa, CA',
        description: 'OC MENA Festival June 19-21, 2026. Orange County, CA. Experience three days of Middle Eastern and North African (MENA) culture, food, music, rides, shopping, and family-friendly fun.',
        ogTitle: 'OC MENA Festival | June 19-21, 2026 | Costa Mesa, CA',
        ogDescription: 'Experience Middle Eastern & North African culture in Orange County with live music, food, bazaars, and immersive attractions. Featuring Dystinct & more.',
        keywords: 'OC MENA Festival, Orange County festival, Costa Mesa events, Middle Eastern festival California, North African festival, Dystinct concert, Pacific Amphitheatre, MENA culture event, OC live music, Orange County cultural festival',
        shareImage: '',
      },
      tickets: {
        title: 'OC MENA Festival | Tickets',
        description: 'Purchase tickets for the OC MENA Festival. Choose from 1-Day, 2-Day, or 3-Day passes to experience three days of MENA culture, food, music, and entertainment in Orange County.',
        ogTitle: 'OC MENA Festival | Tickets',
        ogDescription: 'Get your tickets for OC MENA Festival — 1-Day, 2-Day, or 3-Day passes available. Live music, food, rides, and culture in Costa Mesa.',
        keywords: 'OC MENA Festival tickets, buy tickets, festival passes, Costa Mesa events, MENA festival tickets',
        shareImage: '',
      },
      festivalTickets: {
        title: 'OC MENA Festival | Festival Tickets',
        description: 'Purchase festival admission tickets for the OC MENA Festival. Choose from 1-Day, 2-Day, or 3-Day passes.',
        ogTitle: 'OC MENA Festival | Festival Tickets',
        ogDescription: 'Get your festival admission tickets for OC MENA Festival. Single-day and multi-day passes available.',
        keywords: 'OC MENA Festival tickets, festival admission, Costa Mesa, Orange County festival',
        shareImage: '',
      },
      amphitheaterTickets: {
        title: 'OC MENA Festival | Amphitheater Tickets',
        description: 'Purchase reserved seating tickets for the Pacific Amphitheatre concerts at OC MENA Festival. Featuring Dystinct & more.',
        ogTitle: 'OC MENA Festival | Amphitheater Tickets',
        ogDescription: 'Reserve your seats at the Pacific Amphitheatre for OC MENA Festival concerts. Featuring Dystinct & more.',
        keywords: 'Pacific Amphitheatre tickets, OC MENA Festival concert, Dystinct concert, reserved seating Costa Mesa',
        shareImage: '',
      },
      vendors: {
        title: 'OC MENA Festival | Vendors',
        description: 'Explore the vibrant vendor marketplace at OC MENA Festival. Food, art, fashion, culture, and community in one dynamic bazaar.',
        ogTitle: 'OC MENA Festival | Vendors',
        ogDescription: 'Become a vendor at OC MENA Festival. Food booths, bazaar booths, and cultural marketplace opportunities available.',
        keywords: 'OC MENA Festival vendors, vendor registration, bazaar booth, food vendor, Costa Mesa vendor',
        shareImage: '',
      },
      bazaarVendor: {
        title: 'OC MENA Festival | Bazaar Vendor',
        description: 'Apply to become a bazaar vendor at OC MENA Festival. Showcase your products at the cultural marketplace in Costa Mesa.',
        ogTitle: 'OC MENA Festival | Bazaar Vendor',
        ogDescription: 'Apply for a bazaar booth at OC MENA Festival. Showcase your products at the cultural marketplace.',
        keywords: 'OC MENA Festival bazaar, vendor booth, cultural marketplace, Costa Mesa vendor',
        shareImage: '',
      },
      foodVendor: {
        title: 'OC MENA Festival | Food Vendor',
        description: 'Apply to become a food vendor at OC MENA Festival. Food booths and food truck spots available in Costa Mesa.',
        ogTitle: 'OC MENA Festival | Food Vendor',
        ogDescription: 'Apply for a food booth or food truck spot at OC MENA Festival. Serve guests at the cultural celebration.',
        keywords: 'OC MENA Festival food vendor, food booth, food truck, Costa Mesa food festival',
        shareImage: '',
      },
      about: {
        title: 'OC MENA Festival | About',
        description: 'Learn about OC MENA Festival, a large-scale cultural celebration honoring the rich traditions, creativity, and diversity of the Middle East and North Africa.',
        ogTitle: 'OC MENA Festival | About',
        ogDescription: 'Learn about OC MENA Festival — a celebration of Middle Eastern and North African culture in Orange County.',
        keywords: 'OC MENA Festival about, MENA culture, Orange County cultural festival, Middle Eastern festival',
        shareImage: '',
      },
      whatIsMena: {
        title: 'OC MENA Festival | What is MENA',
        description: 'MENA stands for the Middle East and North Africa, a diverse and vibrant region home to dozens of cultures, languages, traditions, and histories.',
        ogTitle: 'OC MENA Festival | What is MENA',
        ogDescription: 'Discover what MENA means — the Middle East and North Africa, a region rich in culture, history, and tradition.',
        keywords: 'MENA meaning, Middle East North Africa, MENA region, MENA culture',
        shareImage: '',
      },
      faq: {
        title: 'OC MENA Festival | FAQ',
        description: 'Frequently asked questions about OC MENA Festival. Tickets, entry, parking, vendors, and more.',
        ogTitle: 'OC MENA Festival | FAQ',
        ogDescription: 'Find answers to common questions about OC MENA Festival — tickets, parking, entry, vendors, and more.',
        keywords: 'OC MENA Festival FAQ, festival questions, parking, tickets, entry info',
        shareImage: '',
      },
      festivalInfo: {
        title: 'OC MENA Festival | Festival',
        description: 'General information, hours, code of conduct, public safety, and health & safety policies for OC MENA Festival.',
        ogTitle: 'OC MENA Festival | Festival Info',
        ogDescription: 'Festival hours, code of conduct, public safety, and health & safety info for OC MENA Festival.',
        keywords: 'OC MENA Festival info, festival hours, code of conduct, safety info',
        shareImage: '',
      },
      music: {
        title: 'OC MENA Festival | Music & Entertainment',
        description: 'Discover live music and entertainment at OC MENA Festival, featuring artists, comedians, and DJs all weekend while you shop, eat, and explore.',
        ogTitle: 'OC MENA Festival | Music & Entertainment',
        ogDescription: 'Discover live music and entertainment at OC MENA Festival, featuring artists, comedians, and DJs all weekend while you shop, eat, and explore.',
        keywords: 'OC MENA Festival music, concert lineup, Dystinct, Pacific Amphitheatre, live music Costa Mesa',
        shareImage: '',
      },
      sponsors: {
        title: 'OC MENA Festival | Sponsors',
        description: 'Become a sponsor of OC MENA Festival. Diamond, Platinum, Gold, Silver, and Bronze sponsorship tiers with customizable benefits.',
        ogTitle: 'OC MENA Festival | Sponsors',
        ogDescription: 'Partner with OC MENA Festival as a sponsor. Multiple sponsorship tiers with customizable benefits.',
        keywords: 'OC MENA Festival sponsors, sponsorship opportunities, festival partnership, Costa Mesa',
        shareImage: '',
      },
      sponsorsInfo: {
        title: 'OC MENA Festival | Sponsors Info',
        description: 'Learn about sponsorship opportunities at OC MENA Festival. Partner with us to create meaningful engagement with our audience.',
        ogTitle: 'OC MENA Festival | Sponsorship Info',
        ogDescription: 'Learn about sponsorship tiers and benefits at OC MENA Festival.',
        keywords: 'OC MENA Festival sponsorship, sponsor tiers, festival partnership',
        shareImage: '',
      },
      contact: {
        title: 'OC MENA Festival | Contact',
        description: 'Get in touch with the OC MENA Festival team. Sponsor inquiries, vendor questions, press inquiries, and general questions.',
        ogTitle: 'OC MENA Festival | Contact',
        ogDescription: 'Contact the OC MENA Festival team for sponsor, vendor, press, or general inquiries.',
        keywords: 'OC MENA Festival contact, festival inquiries, sponsor contact, vendor contact',
        shareImage: '',
      },
      eventSchedule: {
        title: 'OC MENA Festival | Event Schedule',
        description: 'View the full event schedule for OC MENA Festival. Performances, experiences, and special moments across three days.',
        ogTitle: 'OC MENA Festival | Event Schedule',
        ogDescription: 'Full event schedule for OC MENA Festival — performances, experiences, and special moments.',
        keywords: 'OC MENA Festival schedule, event lineup, festival program, Costa Mesa events',
        shareImage: '',
      },
      eventMap: {
        title: 'OC MENA Festival | Event Map',
        description: 'Navigate the OC MENA Festival grounds with our interactive event map. Find stages, vendors, food, restrooms, and more.',
        ogTitle: 'OC MENA Festival | Event Map',
        ogDescription: 'Navigate the OC MENA Festival grounds — stages, vendors, food, restrooms, and more.',
        keywords: 'OC MENA Festival map, event map, festival grounds, OC Fair',
        shareImage: '',
      },
      mapsDirections: {
        title: 'OC MENA Festival | Maps & Directions',
        description: 'Get directions to OC MENA Festival at the OC Fair & Event Center in Costa Mesa, California.',
        ogTitle: 'OC MENA Festival | Maps & Directions',
        ogDescription: 'Get directions to OC MENA Festival at the OC Fair & Event Center, 88 Fair Dr, Costa Mesa, CA.',
        keywords: 'OC MENA Festival directions, OC Fair Event Center, Costa Mesa directions, festival parking',
        shareImage: '',
      },
      privacyPolicy: {
        title: 'OC MENA Festival | Privacy Policy',
        description: 'Privacy policy for OC MENA Festival and MENA Events, Inc.',
        ogTitle: 'OC MENA Festival | Privacy Policy',
        ogDescription: 'Privacy policy for OC MENA Festival and MENA Events, Inc.',
        keywords: '',
        shareImage: '',
      },
      termsOfUse: {
        title: 'OC MENA Festival | Terms of Use',
        description: 'Terms of use for the OC MENA Festival website and services.',
        ogTitle: 'OC MENA Festival | Terms of Use',
        ogDescription: 'Terms of use for the OC MENA Festival website and services.',
        keywords: '',
        shareImage: '',
      },
      ticketTerms: {
        title: 'OC MENA Festival | Ticket Terms',
        description: 'Ticket terms and conditions for OC MENA Festival admission.',
        ogTitle: 'OC MENA Festival | Ticket Terms',
        ogDescription: 'Ticket terms and conditions for OC MENA Festival admission.',
        keywords: '',
        shareImage: '',
      },
    },
  },

  // Custom CSS overrides (injected into pages)
  customCSS: '',
};

// Helper function to deep merge objects
const deepMerge = (target, source) => {
  const result = { ...target };
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      result[key] = deepMerge(target[key] || {}, source[key]);
    } else if (source[key] !== undefined) {
      result[key] = source[key];
    }
  }
  return result;
};

// Strip HTML tags from a string (e.g. "<p>Hello</p>" → "Hello")
const stripHtml = (str) => {
  if (typeof str !== 'string') return str;
  // Remove HTML tags, decode common entities, and trim
  return str
    .replace(/<[^>]*>/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, ' ')
    .trim();
};

// Recursively sanitize all string values in an object tree
const sanitizeData = (obj) => {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj === 'string') return stripHtml(obj);
  if (Array.isArray(obj)) return obj.map(sanitizeData);
  if (typeof obj === 'object') {
    const result = {};
    for (const key in obj) {
      result[key] = sanitizeData(obj[key]);
    }
    return result;
  }
  return obj;
};

export const getDefaultSiteImages = () => cmsData.siteImages || {};

export const getCmsImageDataFromContent = (content, key) => {
  const imageEntry = content?.siteImages?.[key];
  if (!imageEntry) return null;
  if (typeof imageEntry === 'string') {
    return { path: imageEntry, label: key, usedOn: '' };
  }
  return imageEntry;
};

// Backend origin for resolving media URLs
const _backendOrigin = () =>
  (typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'))
    ? 'http://localhost:8000'
    : 'https://backend-production-18860.up.railway.app';

// Resolve relative media paths to absolute backend URLs
// Handles: /media/..., media/..., and broken URLs like http://localhost:3000/media/...
const _resolveMediaUrl = (path) => {
  if (!path || path.startsWith('data:')) return path;
  // Already pointing to correct backend
  const origin = _backendOrigin();
  if (path.startsWith(origin)) return path;
  // Fix URLs pointing to wrong origin (e.g. localhost:3000/media/...)
  if (path.startsWith('http://') || path.startsWith('https://')) {
    const mediaIdx = path.indexOf('/media/');
    if (mediaIdx !== -1) return `${origin}${path.slice(mediaIdx)}`;
    return path;
  }
  // Relative paths: /media/... or media/...
  if (path.startsWith('/media/')) return `${origin}${path}`;
  if (path.startsWith('media/')) return `${origin}/${path}`;
  // Auto-convert local static assets from legacy PNG/JPG to WebP
  if (path.startsWith('/') && /\.(png|jpg|jpeg)$/i.test(path)) {
    return path.replace(/\.(png|jpg|jpeg)$/i, '.webp');
  }
  return path;
};

// Track broken media URLs so getCmsImagePath returns fallback on React re-renders
const _brokenUrls = new Set();
const _imgFallbackMap = new Map();

// Install a global error handler that catches broken <img> tags
// When an image 404s: mark URL as broken, swap src, AND trigger React re-render
let _imgErrorHandlerInstalled = false;
export const installImgErrorHandler = () => {
  if (_imgErrorHandlerInstalled || typeof document === 'undefined') return;
  _imgErrorHandlerInstalled = true;
  document.addEventListener('error', (e) => {
    const img = e.target;
    if (!(img instanceof HTMLImageElement)) return;
    const src = img.src;
    if (_brokenUrls.has(src)) {
      // Already known broken — apply fallback directly (React may have re-set src)
      const fallback = _imgFallbackMap.get(src);
      if (fallback) img.src = fallback;
      return;
    }
    const fallback = _imgFallbackMap.get(src);
    if (fallback) {
      _brokenUrls.add(src);
      img.src = fallback;
      // Notify React so components re-render and getCmsImagePath returns fallback
      window.dispatchEvent(new CustomEvent('cmsImageBroken'));
    }
  }, true); // capture phase — error events don't bubble
};

export const getCmsImagePathFromContent = (content, key, fallbackPath = '') => {
  const imageEntry = getCmsImageDataFromContent(content, key);
  const resolved = _resolveMediaUrl(imageEntry?.path) || fallbackPath;
  // If this URL already failed, return fallback immediately
  if (resolved && fallbackPath && _brokenUrls.has(resolved)) {
    return fallbackPath;
  }
  // Register fallback so broken images auto-recover
  if (resolved && fallbackPath && resolved !== fallbackPath) {
    _imgFallbackMap.set(resolved, fallbackPath);
  }
  return resolved;
};

export const getCmsImagePath = (key, fallbackPath = '') => {
  return getCmsImagePathFromContent(getCmsData(), key, fallbackPath);
};

// Helper function to get CMS data (instant from cache, backend fetched separately)
export const getCmsData = () => {
  // Return localStorage cache for instant page load
  const savedData = localStorage.getItem('cmsData');
  if (savedData) {
    try {
      const parsed = JSON.parse(savedData);
      const sanitized = sanitizeData(parsed);
      return deepMerge(cmsData, sanitized);
    } catch (e) {
      console.error('Error parsing CMS data:', e);
    }
  }
  return cmsData;
};

// ─── Backend persistence via api.js (correct URLs + auth + token refresh) ───
let _api = null;
const _getApi = () => {
  if (!_api) {
    // Lazy-import to avoid circular dependency
    try { _api = require('../services/api').default; } catch { _api = null; }
  }
  return _api;
};

// Fetch CMS data from backend API (source of truth for all browsers/devices)
export const fetchCmsFromBackend = async () => {
  try {
    const api = _getApi();
    if (!api) { console.warn('CMS: api service not available'); return null; }

    const json = await api.getCmsContent();
    if (!json || (!json.success && !json.data)) return null;

    const backendData = json.data || json;

    // Fix image URLs: resolve any relative media paths to absolute backend URLs
    if (backendData.siteImages && typeof backendData.siteImages === 'object') {
      for (const [k, v] of Object.entries(backendData.siteImages)) {
        if (typeof v === 'object' && v?.path) {
          const resolved = _resolveMediaUrl(v.path);
          if (resolved !== v.path) {
            backendData.siteImages[k] = { ...v, path: resolved };
          }
        }
      }
    }

    // Preserve locally-uploaded images that backend doesn't know about yet
    // (user uploaded but hasn't clicked Save yet — don't overwrite with defaults)
    const currentLocal = getCmsData();
    if (currentLocal.siteImages && backendData.siteImages) {
      for (const [k, localImg] of Object.entries(currentLocal.siteImages)) {
        if (typeof localImg === 'object' && localImg?.path && localImg.path.includes('/media/')) {
          const backendImg = backendData.siteImages[k];
          if (!backendImg?.path || !backendImg.path.includes('/media/')) {
            // Local has uploaded URL, backend has default — keep local
            backendData.siteImages[k] = localImg;
          }
        }
      }
    }

    // Merge with defaults so new fields always exist
    const merged = deepMerge(cmsData, backendData);

    // Cache locally for instant page loads
    localStorage.setItem('cmsData', JSON.stringify(merged));

    // Restore style overrides from backend
    if (backendData._styleOverrides && typeof backendData._styleOverrides === 'object') {
      localStorage.setItem('cmsStyleOverrides', JSON.stringify(backendData._styleOverrides));
    }

    // Snapshot for diff tracking — so next save only sends changes
    _lastSyncedSnapshot = JSON.parse(JSON.stringify(merged));

    window.dispatchEvent(new CustomEvent('cmsDataUpdated', { detail: merged }));
    return merged;
  } catch (e) {
    console.warn('Could not fetch CMS data from backend:', e.message);
    return null;
  }
};

// Snapshot of what was last synced to backend — used to compute diffs
let _lastSyncedSnapshot = null;

// Save CMS data to backend API (required) + local cache
export const saveCmsData = async (data) => {
  // Save ONLY changed sections to backend (fast — sends just a few KB)
  const api = _getApi();
  if (!api) {
    throw new Error('CMS API service unavailable');
  }

  // Build a lean diff: only top-level keys that actually changed
  const prev = _lastSyncedSnapshot || {};
  const diff = {};
  for (const [key, value] of Object.entries(data)) {
    if (key === 'siteImages') {
      // Include siteImages and keep path exactly as-is (including data URLs)
      // so unsynced uploads are not silently dropped from backend persistence.
      const lean = {};
      if (value && typeof value === 'object') {
        for (const [imgKey, imgVal] of Object.entries(value)) {
          if (typeof imgVal === 'object' && imgVal !== null) {
            const { path, ...meta } = imgVal;
            if (path) {
              lean[imgKey] = { ...meta, path };
            } else if (Object.keys(meta).length > 0) {
              lean[imgKey] = meta;
            }
          }
        }
      }
      if (Object.keys(lean).length > 0 && JSON.stringify(lean) !== JSON.stringify(prev[key])) {
        diff[key] = lean;
      }
      continue;
    }
    if (JSON.stringify(value) !== JSON.stringify(prev[key])) {
      diff[key] = value;
    }
  }

  if (Object.keys(diff).length === 0) {
    console.log('[CMS] No changes to sync to backend');
  } else {
    console.log('[CMS] Syncing changed sections:', Object.keys(diff).join(', '));
    await api.saveCmsContent(diff);
    console.log('[CMS] Saved to backend successfully');
  }

  // Only mark as synced after backend success.
  _lastSyncedSnapshot = JSON.parse(JSON.stringify(data));

  // Keep local cache in sync for instant reads and live updates.
  localStorage.setItem('cmsData', JSON.stringify(data));
  if (data._styleOverrides) {
    localStorage.setItem('cmsStyleOverrides', JSON.stringify(data._styleOverrides));
  }
  window.dispatchEvent(new CustomEvent('cmsDataUpdated', { detail: data }));

  return true;
};

// Helper function to reset to defaults
export const resetCmsData = async () => {
  localStorage.removeItem('cmsData');
  localStorage.removeItem('cmsStyleOverrides');
  window.dispatchEvent(new CustomEvent('cmsDataUpdated', { detail: cmsData }));

  // Also reset on backend
  try {
    const api = _getApi();
    if (api) await api.saveCmsContent(cmsData);
  } catch (e) {
    console.warn('Could not reset CMS data on backend:', e.message);
  }

  return cmsData;
};

export default cmsData;
